import Button from 'components/_UI/Button'
import InfoTooltip from 'components/_UI/InfoTooltip'
import Loader from 'components/_UI/Loader'
import Table from 'components/_UI/Table'
import Text from 'components/_UI/Text'
import date from 'helpers/date'
import React from 'react'
import { Info, Trash2 } from 'lucide-react'
import styled from 'styled-components'
import { FullyCentered } from 'styled/alignment/Center'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'

export default function ListDrawer({
  giveaway,
  isLoading,
  toggleAction
}) {

  
  const listGiveaway = giveaway?.winners?.map((winner) => ({
    sorteado: (
      <Text key={winner?.id} name='small'>
        {winner?.user?.name}
      </Text>
    ),
    data: <Text name='small'>{date.format(giveaway?.created_at)}</Text>,
    action: (
      <ContentAction>
        <InfoTooltip
          bgColor={colors.night}
          text={'Visualizar detalhes do sorteio'}
          type='none'
        >
          <Info
            size={20}
            color={colors.primaryLight}
           
            onClick={() =>
              toggleAction({
                item: { giveaway, winner },
                type: 'detailDrawer',
              })
            }
          />
        </InfoTooltip>
      </ContentAction>
    ),
  }));

  return (
    <>
      <Column marginTop={'10px'}>
        <Row marginTop={'10px'} verticalCenter>
          <Text
      
            color={colors.nightDark}
            paddingBottom={'0px'}
            marginBottom={'0'}
            
            type='bold'
          >
            Nome do sorteio:
          </Text> 
          <Text marginLeft={'5px'} paddingBottom={'0px'}>{giveaway?.name}</Text>
        </Row>
        
        <Row>
            <Text type='bold' color={colors.nightDark} paddingBottom={'0px'}>Público do sorteio:</Text>
            <Text marginLeft={'5px'} paddingBottom={'0px'}>{giveaway?.scope == 'all' ?  'Todos os participantes ': 'Apenas quem fez check-in' } </Text>
        </Row>
        <ContentButtonDelete>
            <DeleteContainer
              onClick={() =>
                toggleAction({
                  item: { giveaway },
                  type: 'deleteDrawer',
                  })
              }
            >
              <Text paddingBottom={'0px'}>
                <Trash2
                  size={16}
                  color={colors.danger}
                />
              </Text>
              
            </DeleteContainer>
        </ContentButtonDelete>
      </Column>
      

      {isLoading ? (
        <Loader />
      ) : (
        <ContainerTable>
          <Table
            rows={listGiveaway}
            columns={['Sorteado', 'Data', 'Ação']}
          />
        </ContainerTable>
      )}
    </>
  );
}

const ContentAction = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  transition: all ease-in-out 0.25s;

  & > div > svg {
    &:hover {
      transform: scale(1.1);
    }
  }


`

const ContainerTable = styled(Column)`
  
  & > div {
    margin-top: 0px;
  }
`

const ContentButtonDelete = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  @media screen and (max-width: ${breakpoints.lg}) {
    margin-bottom: 10px
  }
`;

const DeleteContainer = styled(FullyCentered)`
    width: auto;
    height: auto;
    border: 1px solid ${colors.danger};
    border-radius: 4px;
    margin-top: 5px;
    cursor: pointer;
    padding: 5px;
    & > p {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    @media screen and (min-width: ${breakpoints.lg}) {
      margin-bottom: 10px;
    }

`;